import BkashIcon from '../../assets/icons/payment-providers/BkashIcon';
import NagadIcon from '../../assets/icons/payment-providers/NagadIcon';
import { PAYMENT_METHOD } from '../../types/enums';
import type { PaymentProvider } from '../../types/payment';

export const pay2LocalPaymentProviders: PaymentProvider[] = [
  {
    label: 'Bkash',
    value: PAYMENT_METHOD.BKASH,
    icon: BkashIcon,
  },
  {
    label: 'Nagad',
    value: PAYMENT_METHOD.NAGAD,
    icon: NagadIcon,
  },
];
